/* assets/mm-myth-fact-quiz.js — <mm-myth-fact-quiz>: Auswahl färbt, Erklärung erscheint, Score zählt, Antworten änderbar, Code erst bei voller Punktzahl */
(function () {
  'use strict';
  if (!('customElements' in window) || customElements.get('mm-myth-fact-quiz')) return;
  function track(evt, data) { if (window.dataLayer && typeof window.dataLayer.push === 'function') window.dataLayer.push(Object.assign({ event: evt }, data)); }
  class MMQuiz extends HTMLElement {
    connectedCallback() {
      this.total = parseInt(this.dataset.total, 10) || this.querySelectorAll('[data-mm-question]').length;
      this.answers = {}; this.completed = false;
      this._onClick = this._onClick.bind(this); this.addEventListener('click', this._onClick);
    }
    disconnectedCallback() { this.removeEventListener('click', this._onClick); }
    _onClick(evt) {
      var copy = evt.target.closest('[data-mm-copy]'); if (copy && this.contains(copy)) return this._copy(copy);
      var btn = evt.target.closest('[data-mm-pick]'); if (!btn || !this.contains(btn)) return;
      var card = btn.closest('[data-mm-question]'); if (!card) return;
      var pick = btn.dataset.mmPick, right = card.dataset.answer, ok = pick === right, idx = parseInt(card.dataset.index, 10);
      card.querySelectorAll('[data-mm-pick]').forEach(function (b) {
        var on = b === btn; b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.classList.toggle('is-right', on && ok); b.classList.toggle('is-wrong', on && !ok);
      });
      var ex = card.querySelector('[data-mm-explain]'), v = card.querySelector('[data-mm-verdict]');
      if (v) { v.textContent = ok ? this.dataset.rightLabel : this.dataset.wrongLabel; v.classList.toggle('is-wrong', !ok); }
      if (ex) ex.hidden = false;
      this.answers[idx] = ok;
      track('mm_quiz_answer', { index: idx, correct: ok });
      this._update();
    }
    _update() {
      var keys = Object.keys(this.answers), score = keys.filter(k => this.answers[k]).length;
      var s = this.querySelector('[data-mm-score]'); if (s) s.textContent = String(score);
      var reward = this.querySelector('[data-mm-reward]'); if (reward) reward.hidden = !(this.total > 0 && score === this.total);
      if (!this.completed && keys.length === this.total && this.total > 0) { this.completed = true; track('mm_quiz_complete', { score: score, total: this.total }); }
    }
    _copy(btn) {
      var code = this.querySelector('[data-mm-code]'); if (!code) return;
      var text = code.textContent.trim(), label = btn.textContent, done = () => { btn.textContent = btn.dataset.copiedLabel || label; setTimeout(() => { btn.textContent = label; }, 2000); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done, done);
      else { var r = document.createRange(); r.selectNodeContents(code); var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(r); try { document.execCommand('copy'); } catch (e) {} sel.removeAllRanges(); done(); }
    }
  }
  customElements.define('mm-myth-fact-quiz', MMQuiz);
})();
